// The homepage's short scope notes supplement the existing feature rows.
// Shared with the initial HTML; detailed inclusions remain on /pricing.
export const HOME_PLAN_SCOPE = {
  crm: "Includes one landing page, built by our team.",
  receptionist: "Includes phone answering and website chat. CRM and a landing page are not included.",
  bundle: "Includes the CRM, phone answering, website chat, and one landing page.",
} as const;
